/* eslint-disable react/prop-types */ // TODO: add props
import { DEFAULT_CANVAS_HEIGHT } from 'core/constants';
import style from './IllustrationAnswer.scss';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';

const IllustrationAnswer = ({ response }) => {
  const drawingSVG =
    response?.getIn(['field_responses', 0, 'submitted_drawing_svg']) || '';

  return (
    <div
      className={style.illustrationAnswerContainer}
      dangerouslySetInnerHTML={{ __html: drawingSVG }}
      style={{ height: `${DEFAULT_CANVAS_HEIGHT}px` }}
      data-test={`answer-${EXAM_QUESTION_TYPES.ILLUSTRATION}`}
    />
  );
};

export default IllustrationAnswer;
